import React from 'react';
import { MBStackedUsers } from '../message/stackedUsers';

export interface MBSeenByImagesProps {
  users: MBAPI.ShortUser[];
  isCountVisible?: boolean;
}

export function MBSeenByImages({ users, isCountVisible }: MBSeenByImagesProps) {
  return <MBStackedUsers users={users} small isCountVisible={isCountVisible} />;
}
